import {
  authHeader,
  handleResponse,
  handleWithClearErrorResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getFeatureFlagsList() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const endPoint = `/api/admin/v1/features`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getFeatureFlags(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { featureId } = queryParams;
  const endPoint = `/api/admin/v1/features/${featureId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function getFeatureAvailableGroups(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { featureId } = queryParams;
  const endPoint = `/api/admin/v1/features/${featureId}/groups/available`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function featureGlobalActivate(queryParams) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { featureId } = queryParams;

  const endPoint = `/api/admin/v1/features/${featureId}/global`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function addFeatureTargetGroups(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { featureId } = queryParams;
  const endPoint = `/api/admin/v1/features/${featureId}/groups`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const featureFlagsService = {
  getFeatureFlags,
  getFeatureFlagsList,
  getFeatureAvailableGroups,
  featureGlobalActivate,
  addFeatureTargetGroups,
};
